var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "template-form",
      attrs: { autocomplete: "off", "data-vv-scope": "form-request" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.save("form-request")
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 mb-17" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("label", { staticClass: "template-label" }, [
              _vm._v(_vm._s(_vm.configureFields.firstName.chatbotLabelName))
            ]),
            _c("span", { staticClass: "required-symbol" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ask.first,
                  expression: "ask.first"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                { name: "focus", rawName: "v-focus" }
              ],
              staticClass: "form-control pt-input input-focus input-value",
              class: {
                "request-form-error-border": _vm.errors.has(
                  "form-request.first"
                )
              },
              attrs: {
                type: "text",
                id: "firstName",
                "aria-label":
                  _vm.configureFields.firstName &&
                  _vm.configureFields.firstName.chatbotLabelName
                    ? _vm.configureFields.firstName.chatbotLabelName
                    : "First name",
                name: "first",
                placeholder: ""
              },
              domProps: { value: _vm.ask.first },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.ask, "first", $event.target.value)
                  },
                  function(e) {
                    return (_vm.ask.first = _vm.sanitizeInput(e.target.value))
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-request.first"),
                    expression: "errors.has('form-request.first')"
                  }
                ],
                staticClass: "error"
              },
              [_vm._v(_vm._s(_vm.errors.first("form-request.first")))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-17" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("label", { staticClass: "template-label" }, [
              _vm._v(_vm._s(_vm.configureFields.lastName.chatbotLabelName))
            ]),
            _c("span", { staticClass: "required-symbol" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ask.last,
                  expression: "ask.last"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "form-control pt-input input-focus input-value",
              class: {
                "request-form-error-border": _vm.errors.has("form-request.last")
              },
              attrs: {
                type: "text",
                id: "lastNAme",
                "aria-label":
                  _vm.configureFields.lastName &&
                  _vm.configureFields.lastName.chatbotLabelName
                    ? _vm.configureFields.lastName.chatbotLabelName
                    : "Last name",
                name: "last",
                placeholder: ""
              },
              domProps: { value: _vm.ask.last },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.ask, "last", $event.target.value)
                  },
                  function(e) {
                    return (_vm.ask.last = _vm.sanitizeInput(e.target.value))
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-request.last"),
                    expression: "errors.has('form-request.last')"
                  }
                ],
                staticClass: "error"
              },
              [_vm._v(_vm._s(_vm.errors.first("form-request.last")))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-17" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("label", { staticClass: "template-label" }, [
              _vm._v(_vm._s(_vm.configureFields.emailAddress.chatbotLabelName))
            ]),
            _c("span", { staticClass: "required-symbol" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ask.email,
                  expression: "ask.email"
                },
                {
                  name: "validate",
                  rawName: "v-validate.continues",
                  value: "required|email",
                  expression: "'required|email'",
                  modifiers: { continues: true }
                }
              ],
              staticClass: "form-control pt-input input-focus input-value",
              class: {
                "request-form-error-border": _vm.errors.has(
                  "form-request.email"
                )
              },
              attrs: {
                type: "text",
                id: "email",
                "aria-label":
                  _vm.configureFields.emailAddress &&
                  _vm.configureFields.emailAddress.chatbotLabelName
                    ? _vm.configureFields.emailAddress.chatbotLabelName
                    : "Email address",
                name: "email",
                placeholder: ""
              },
              domProps: { value: _vm.ask.email },
              on: {
                change: _vm.checkMemberStatus,
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.ask, "email", $event.target.value)
                  },
                  function(e) {
                    return (_vm.ask.email = _vm.sanitizeInput(e.target.value))
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-request.email"),
                    expression: "errors.has('form-request.email')"
                  }
                ],
                staticClass: "error"
              },
              [_vm._v(_vm._s(_vm.errors.first("form-request.email")))]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.configureFields.memberRole &&
        _vm.configureFields.memberRole.include &&
        _vm.configureFields.memberRole.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(_vm._s(_vm.memberRole.chatbotLabelName))
                ]),
                _vm.checkAndValidate1("memberRole")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "" + _vm.checkAndValidate1("memberRole"),
                        expression: "`${checkAndValidate1('memberRole')}`"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.dynamicFields.memberRole,
                        expression: "dynamicFields.memberRole"
                      }
                    ],
                    staticClass:
                      "form-control pt-input input-focus input-value template-drop-down select-dropdown requestPageDropdown",
                    attrs: { name: "memberRole" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.dynamicFields,
                          "memberRole",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "option",
                      {
                        staticStyle: { display: "none" },
                        attrs: { value: "", selected: "", disabled: "" }
                      },
                      [_vm._v("Select role")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.memberRole.memberValue, function(role) {
                      return _c(
                        "option",
                        { key: role, domProps: { value: role.trim() } },
                        [_vm._v(_vm._s(role.trim()))]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.memberRole"),
                        expression: "errors.has('form-request.memberRole')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("form-request.memberRole")))]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.adviceArea &&
        _vm.configureFields.adviceArea.include &&
        _vm.configureFields.adviceArea.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(_vm._s(_vm.adviceArea.chatbotLabelName))
                ]),
                _vm.checkAndValidate1("adviceArea")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "" + _vm.checkAndValidate1("adviceArea"),
                        expression: "`${checkAndValidate1('adviceArea')}`"
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.dynamicFields.adviceArea,
                        expression: "dynamicFields.adviceArea"
                      }
                    ],
                    staticClass:
                      "form-control pt-input input-focus input-value template-drop-down select-dropdown requestPageDropdown",
                    attrs: { name: "adviceArea" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.dynamicFields,
                          "adviceArea",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "option",
                      {
                        staticStyle: { display: "none" },
                        attrs: { value: "", selected: "", disabled: "" }
                      },
                      [_vm._v("Select Area")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.adviceArea.memberValue, function(role) {
                      return _c(
                        "option",
                        { key: role, domProps: { value: role.trim() } },
                        [_vm._v(_vm._s(role.trim()))]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.adviceArea"),
                        expression: "errors.has('form-request.adviceArea')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("form-request.adviceArea")))]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.phoneNumber &&
        _vm.configureFields.phoneNumber.include &&
        _vm.configureFields.phoneNumber.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(
                    _vm._s(_vm.configureFields.phoneNumber.chatbotLabelName)
                  )
                ]),
                _vm.checkAndValidate1("phoneNumber")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dynamicFields.phoneNumber,
                      expression: "dynamicFields.phoneNumber"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate.continues",
                      value: "" + _vm.checkAndValidate1("phoneNumber"),
                      expression: "`${checkAndValidate1('phoneNumber')}`",
                      modifiers: { continues: true }
                    }
                  ],
                  staticClass: "form-control pt-input input-focus input-value",
                  class: {
                    "request-form-error-border": _vm.errors.has(
                      "form-request.phoneNumber"
                    )
                  },
                  attrs: {
                    type: "text",
                    id: "phoneNumber",
                    "aria-label":
                      _vm.configureFields.phoneNumber &&
                      _vm.configureFields.phoneNumber.chatbotLabelName
                        ? _vm.configureFields.phoneNumber.chatbotLabelName
                        : "Phone number",
                    name: "phoneNumber"
                  },
                  domProps: { value: _vm.dynamicFields.phoneNumber },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.dynamicFields,
                          "phoneNumber",
                          $event.target.value
                        )
                      },
                      function(e) {
                        return (_vm.dynamicFields.phoneNumber = _vm.sanitizeInput(
                          e.target.value
                        ))
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.phoneNumber"),
                        expression: "errors.has('form-request.phoneNumber')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.errors.first("form-request.phoneNumber")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.linkedInProfile &&
        _vm.configureFields.linkedInProfile.include &&
        _vm.configureFields.linkedInProfile.include === true
          ? _c("div", { staticClass: "col-md-12 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(
                    _vm._s(_vm.configureFields.linkedInProfile.chatbotLabelName)
                  )
                ]),
                _vm.checkAndValidate1("linkedInProfile")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dynamicFields.linkedInProfile,
                      expression: "dynamicFields.linkedInProfile"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required:
                          _vm.configureFields.linkedInProfile.require == true
                            ? true
                            : false,
                        regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                      },
                      expression:
                        "{ required: configureFields.linkedInProfile.require == true ? true: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                    }
                  ],
                  staticClass: "form-control pt-input input-focus input-value",
                  class: {
                    "request-form-error-border": _vm.errors.has(
                      "form-request.linkedInProfile"
                    )
                  },
                  attrs: {
                    type: "text",
                    id: "linkedInProfile",
                    name: "linkedInProfile",
                    "aria-label":
                      _vm.configureFields.linkedInProfile &&
                      _vm.configureFields.linkedInProfile.chatbotLabelName
                        ? _vm.configureFields.linkedInProfile.chatbotLabelName
                        : "LinkedIn URL"
                  },
                  domProps: { value: _vm.dynamicFields.linkedInProfile },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.dynamicFields,
                          "linkedInProfile",
                          $event.target.value
                        )
                      },
                      function(e) {
                        return (_vm.dynamicFields.linkedInProfile = _vm.sanitizeUrl(
                          e.target.value
                        ))
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.linkedInProfile"),
                        expression: "errors.has('form-request.linkedInProfile')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.errors.first("form-request.linkedInProfile"))
                    )
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.college &&
        _vm.configureFields.college.include &&
        _vm.configureFields.college.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(_vm._s(_vm.configureFields.college.chatbotLabelName))
                ]),
                _vm.checkAndValidate1("college")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dynamicFields.college,
                      expression: "dynamicFields.college"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate.continues",
                      value: "" + _vm.checkAndValidate1("college"),
                      expression: "`${checkAndValidate1('college')}`",
                      modifiers: { continues: true }
                    }
                  ],
                  staticClass: "form-control pt-input input-focus input-value",
                  class: {
                    "request-form-error-border": _vm.errors.has(
                      "form-request.college"
                    )
                  },
                  attrs: {
                    type: "text",
                    id: "college",
                    "aria-label":
                      _vm.configureFields.college &&
                      _vm.configureFields.college.chatbotLabelName
                        ? _vm.configureFields.college.chatbotLabelName
                        : "College",
                    name: "college"
                  },
                  domProps: { value: _vm.dynamicFields.college },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.dynamicFields,
                          "college",
                          $event.target.value
                        )
                      },
                      function(e) {
                        return (_vm.dynamicFields.college = _vm.sanitizeInput(
                          e.target.value
                        ))
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.college"),
                        expression: "errors.has('form-request.college')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("form-request.college")))]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.major &&
        _vm.configureFields.major.include &&
        _vm.configureFields.major.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c(
                  "label",
                  { staticClass: "template-label", attrs: { for: "major" } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.configureFields.major.chatbotLabelName ||
                          _vm.configureFields.major.labelName
                      )
                    ),
                    _vm.checkAndValidate1("major")
                      ? _c("span", { staticClass: "required-symbol" }, [
                          _vm._v(" *")
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedMajorTemp,
                        expression: "selectedMajorTemp"
                      }
                    ],
                    staticClass:
                      "form-control pt-input input-focus input-value template-drop-down select-dropdown requestPageDropdown",
                    attrs: {
                      id: "major",
                      name: "majorSelect",
                      "aria-required": _vm.checkAndValidate1("major")
                        ? "true"
                        : "false",
                      "data-vv-validate-on": "change|blur"
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedMajorTemp = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.onMajorSelect
                      ]
                    }
                  },
                  [
                    _c(
                      "option",
                      {
                        staticStyle: { display: "none" },
                        attrs: { value: "", selected: "", disabled: "" }
                      },
                      [
                        _vm._v(
                          "Select " +
                            _vm._s(
                              _vm.configureFields.major.labelName || "Major"
                            )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.major.memberValue, function(m, idx) {
                      return _c(
                        "option",
                        { key: "major-" + idx, domProps: { value: m.trim() } },
                        [_vm._v(_vm._s(m.trim()))]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "" + _vm.checkAndValidate1("major"),
                      expression: "`${checkAndValidate1('major')}`"
                    }
                  ],
                  attrs: {
                    type: "hidden",
                    name: "major",
                    "data-vv-validate-on": "change|blur",
                    "aria-describedby": _vm.checkAndValidate1("major")
                      ? "required-note"
                      : null
                  },
                  domProps: { value: _vm.majorJoined }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.major"),
                        expression: "errors.has('form-request.major')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("form-request.major")))]
                ),
                _vm._v(" "),
                _vm.dynamicFields.major && _vm.dynamicFields.major.length
                  ? _c(
                      "div",
                      { staticClass: "selected-chips" },
                      _vm._l(_vm.dynamicFields.major, function(m, idx) {
                        return _c(
                          "span",
                          { key: "major-chip-" + m, staticClass: "chip" },
                          [
                            _vm._v(_vm._s(m) + "\n\t\t\t\t\t\t"),
                            _c(
                              "button",
                              {
                                staticClass: "chip-close",
                                attrs: {
                                  type: "button",
                                  "aria-label": "Remove " + m
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.removeMajorByValue(m)
                                  }
                                }
                              },
                              [_vm._v("×")]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.classYear &&
        _vm.configureFields.classYear.include &&
        _vm.configureFields.classYear.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(_vm._s(_vm.configureFields.classYear.chatbotLabelName))
                ]),
                _vm.checkAndValidate1("year")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dynamicFields.year,
                      expression: "dynamicFields.year"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate.continues",
                      value: "" + _vm.checkAndValidate1("year"),
                      expression: "`${checkAndValidate1('year')}`",
                      modifiers: { continues: true }
                    }
                  ],
                  staticClass: "form-control pt-input input-focus input-value",
                  class: {
                    "request-form-error-border": _vm.errors.has(
                      "form-request.year"
                    )
                  },
                  attrs: {
                    type: "text",
                    id: "year",
                    "aria-label":
                      _vm.configureFields.classYear &&
                      _vm.configureFields.classYear.chatbotLabelName
                        ? _vm.configureFields.classYear.chatbotLabelName
                        : "Class year",
                    name: "year"
                  },
                  domProps: { value: _vm.dynamicFields.year },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.dynamicFields, "year", $event.target.value)
                      },
                      function(e) {
                        return (_vm.dynamicFields.year = _vm.sanitizeInput(
                          e.target.value
                        ))
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.year"),
                        expression: "errors.has('form-request.year')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("form-request.year")))]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.title &&
        _vm.configureFields.title.include &&
        _vm.configureFields.title.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(_vm._s(_vm.configureFields.title.chatbotLabelName))
                ]),
                _vm.checkAndValidate1("role")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dynamicFields.role,
                      expression: "dynamicFields.role"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate.continues",
                      value: "" + _vm.checkAndValidate1("role"),
                      expression: "`${checkAndValidate1('role')}`",
                      modifiers: { continues: true }
                    }
                  ],
                  staticClass: "form-control pt-input input-focus input-value",
                  class: {
                    "request-form-error-border": _vm.errors.has(
                      "form-request.role"
                    )
                  },
                  attrs: {
                    type: "text",
                    id: "role",
                    "aria-label":
                      _vm.configureFields.title &&
                      _vm.configureFields.title.chatbotLabelName
                        ? _vm.configureFields.title.chatbotLabelName
                        : "Role",
                    name: "role"
                  },
                  domProps: { value: _vm.dynamicFields.role },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.dynamicFields, "role", $event.target.value)
                      },
                      function(e) {
                        return (_vm.dynamicFields.role = _vm.sanitizeInput(
                          e.target.value
                        ))
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.role"),
                        expression: "errors.has('form-request.role')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.errors.first("form-request.role")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.organization &&
        _vm.configureFields.organization.include &&
        _vm.configureFields.organization.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(
                    _vm._s(_vm.configureFields.organization.chatbotLabelName)
                  )
                ]),
                _vm.checkAndValidate1("organization")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dynamicFields.organization,
                      expression: "dynamicFields.organization"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate.continues",
                      value: "" + _vm.checkAndValidate1("organization"),
                      expression: "`${checkAndValidate1('organization')}`",
                      modifiers: { continues: true }
                    }
                  ],
                  staticClass: "form-control pt-input input-focus input-value",
                  class: {
                    "request-form-error-border": _vm.errors.has(
                      "form-request.organization"
                    )
                  },
                  attrs: {
                    type: "text",
                    id: "organization",
                    "aria-label":
                      _vm.configureFields.organization &&
                      _vm.configureFields.organization.chatbotLabelName
                        ? _vm.configureFields.organization.chatbotLabelName
                        : "Organization",
                    name: "organization"
                  },
                  domProps: { value: _vm.dynamicFields.organization },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.dynamicFields,
                          "organization",
                          $event.target.value
                        )
                      },
                      function(e) {
                        return (_vm.dynamicFields.organization = _vm.sanitizeInput(
                          e.target.value
                        ))
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.organization"),
                        expression: "errors.has('form-request.organization')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.errors.first("form-request.organization"))
                    )
                  ]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.configureFields.studentId &&
        _vm.configureFields.studentId.include &&
        _vm.configureFields.studentId.include === true
          ? _c("div", { staticClass: "col-md-6 mb-17" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("label", { staticClass: "template-label" }, [
                  _vm._v(_vm._s(_vm.configureFields.studentId.chatbotLabelName))
                ]),
                _vm.checkAndValidate1("studentId")
                  ? _c("span", { staticClass: "required-symbol" }, [
                      _vm._v(" *")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dynamicFields.studentId,
                      expression: "dynamicFields.studentId"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate.continues",
                      value: "" + _vm.checkAndValidate1("studentId"),
                      expression: "`${checkAndValidate1('studentId')}`",
                      modifiers: { continues: true }
                    }
                  ],
                  staticClass: "form-control pt-input input-focus input-value",
                  class: {
                    "request-form-error-border": _vm.errors.has(
                      "form-request.studentId"
                    )
                  },
                  attrs: {
                    type: "text",
                    id: "studentId",
                    "aria-label":
                      _vm.configureFields.studentId &&
                      _vm.configureFields.studentId.chatbotLabelName
                        ? _vm.configureFields.studentId.chatbotLabelName
                        : "Student ID",
                    name: "studentId"
                  },
                  domProps: { value: _vm.dynamicFields.studentId },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.dynamicFields,
                          "studentId",
                          $event.target.value
                        )
                      },
                      function(e) {
                        return (_vm.dynamicFields.studentId = _vm.sanitizeInput(
                          e.target.value
                        ))
                      }
                    ]
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.studentId"),
                        expression: "errors.has('form-request.studentId')"
                      }
                    ],
                    staticClass: "error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("form-request.studentId")))]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12 mb-17" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("label", { staticClass: "template-label" }, [
              _vm._v(_vm._s(_vm.configureFields.subject.chatbotLabelName))
            ]),
            _c("span", { staticClass: "required-symbol" }, [_vm._v(" *")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ask.subject,
                  expression: "ask.subject"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass:
                "form-control pt-input w-100 input-focus input-value",
              class: {
                "request-form-error-border": _vm.errors.has(
                  "form-request.title"
                )
              },
              attrs: {
                type: "text",
                id: "title",
                placeholder: this.requestForm.subjectLine,
                "aria-label":
                  _vm.configureFields.subject &&
                  _vm.configureFields.subject.chatbotLabelName
                    ? _vm.configureFields.subject.chatbotLabelName
                    : "Subject",
                name: "title"
              },
              domProps: { value: _vm.ask.subject },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.ask, "subject", $event.target.value)
                  },
                  function(e) {
                    return (_vm.ask.subject = _vm.sanitizeInput(e.target.value))
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("form-request.title"),
                    expression: "errors.has('form-request.title')"
                  }
                ],
                staticClass: "error"
              },
              [_vm._v(_vm._s(_vm.errors.first("form-request.title")))]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.configureFields.dueDate &&
        _vm.configureFields.dueDate.include &&
        _vm.configureFields.dueDate.include === true
          ? _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("label", { staticClass: "template-label" }, [
                    _vm._v(_vm._s(_vm.configureFields.dueDate.chatbotLabelName))
                  ]),
                  _vm.checkAndValidate1("dueDate")
                    ? _c("span", { staticClass: "required-symbol" }, [
                        _vm._v(" *")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("datepicker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate.continues",
                        value: "" + _vm.checkAndValidate1("dueDate"),
                        expression: "`${checkAndValidate1('dueDate')}`",
                        modifiers: { continues: true }
                      }
                    ],
                    staticClass: "input-focus template-input-date-picker",
                    class: {
                      "request-form-error-border": _vm.errors.has(
                        "form-request.dueDate"
                      )
                    },
                    attrs: {
                      id: "dueDate",
                      name: "dueDate",
                      format: _vm.DatePickerFormat,
                      disabledDates: _vm.disabledDates
                    },
                    model: {
                      value: _vm.dynamicFields.dueDate,
                      callback: function($$v) {
                        _vm.$set(_vm.dynamicFields, "dueDate", $$v)
                      },
                      expression: "dynamicFields.dueDate"
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("form-request.dueDate"),
                          expression: "errors.has('form-request.dueDate')"
                        }
                      ],
                      staticClass: "error"
                    },
                    [_vm._v(_vm._s(_vm.errors.first("form-request.dueDate")))]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("label", { staticClass: "template-label" }, [
            _vm._v(_vm._s(_vm.configureFields.question.chatbotLabelName))
          ]),
          _c("span", { staticClass: "required-symbol" }, [_vm._v(" *")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "input-group pd-remove unsubscribe-height input-focus template-input-text-area"
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ask.text,
                    expression: "ask.text"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate.continues",
                    value: "required|max:2000",
                    expression: "'required|max:2000'",
                    modifiers: { continues: true }
                  }
                ],
                staticClass:
                  "form-control pt-input request-form-question-textarea",
                class: {
                  "request-form-error-border": _vm.errors.has(
                    "form-request.message"
                  )
                },
                attrs: {
                  id: "message",
                  placeholder: this.requestForm.question,
                  "aria-label":
                    _vm.configureFields.question &&
                    _vm.configureFields.question.chatbotLabelName
                      ? _vm.configureFields.question.chatbotLabelName
                      : "Message",
                  name: "message",
                  maxlength: _vm.max,
                  rows: "20"
                },
                domProps: { value: _vm.ask.text },
                on: {
                  keyup: _vm.countdown,
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.ask, "text", $event.target.value)
                    },
                    function(e) {
                      return (_vm.ask.text = _vm.sanitizeInput(e.target.value))
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "form-group pd-remove unsubscribe-btn mb-0-custom"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "char-counter template-subject-counter",
                      class: { "char-count-error": _vm.exceedsMaxCount }
                    },
                    [_vm._v(_vm._s(_vm.remainingCount) + "  / 2000")]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "error error-mb--2" },
            _vm._l(_vm.errors.collect("form-request.message"), function(
              error,
              index
            ) {
              return _c("span", { key: index }, [_vm._v(_vm._s(error))])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _vm.configureFields.disclaimer &&
      _vm.configureFields.disclaimer.include &&
      _vm.configureFields.disclaimer.include === true
        ? _c("div", { staticClass: "row mlr0" }, [
            _c(
              "div",
              { staticClass: "form-group disclaimer" },
              [
                _c("md-checkbox", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.continues",
                      value: "" + _vm.checkAndValidate1("disclaimer"),
                      expression: "`${checkAndValidate1('disclaimer')}`",
                      modifiers: { continues: true }
                    }
                  ],
                  staticClass: "form-control template-checkbox pt-0",
                  attrs: { name: "disclaimer", id: "disclaimer" },
                  on: {
                    change: function($event) {
                      return _vm.updateDisclaimer()
                    }
                  },
                  model: {
                    value: _vm.dynamicFields.disclaimer,
                    callback: function($$v) {
                      _vm.$set(_vm.dynamicFields, "disclaimer", $$v)
                    },
                    expression: "dynamicFields.disclaimer"
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  staticClass: "html-disclaimer",
                  attrs: { for: "disclaimer" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.configureFields.disclaimer.chatbotLabelName
                    )
                  }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("form-request.disclaimer"),
                        expression: "errors.has('form-request.disclaimer')"
                      }
                    ],
                    staticClass: "error error-mt-2 template-checkbox-error"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("form-request.disclaimer")))]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.configureFields.disclaimer &&
      _vm.configureFields.disclaimer.include === false
        ? _c("div", { staticClass: "template-mb-30" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-block text-right mlr0" },
        [
          _c(
            "md-button",
            {
              staticClass:
                "btn btn_info template-review-submit template-button template-button-width",
              style: _vm.reviewBtn,
              attrs: { type: "submit", name: "unsubscribe" }
            },
            [_vm._v("Review\n\t\t\t\t")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "helper-text template-label mb-0-custom" },
      [
        _c("strong", [_vm._v("Note:")]),
        _vm._v(
          " Does your request have an expiration date after which an answer is no longer desirable?"
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f59655a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f59655a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/__CommunityRequestForm.vue
// module id = null
// module chunks = 